import React from 'react';
import MyNormalText from './myNormalText';
import {GLOBAL_BORDER_RADIUS} from '../../costants';

const MyToggle = ({isActive, onToggle, title, premiumPalette, disabled = false}) => {

    const handleToggle = () => {
        if (disabled) return
        const newState = !isActive
        if (onToggle) {
            onToggle(newState)
        }
    }

    const wrapperStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: 5,
        borderRadius: GLOBAL_BORDER_RADIUS,
        backgroundColor: premiumPalette.primaryColorFourthAlternative,
        opacity: disabled ? 0.6 : 1
    }

    const containerStyle = {
        width: '50px',
        height: '24px',
        backgroundColor: disabled ? '#e0e0e0' : isActive ? premiumPalette.primaryColor : '#ccc',
        borderRadius: '12px',
        position: 'relative',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'background-color 0.2s',
    }

    const sliderStyle = {
        width: '20px',
        height: '20px',
        backgroundColor: disabled ? '#f5f5050' : 'white',
        borderRadius: '50%',
        position: 'absolute',
        top: '2px',
        left: '2px',
        transition: 'transform 0.2s',
        transform: isActive ? 'translateX(26px)' : 'translateX(0)'
    }

    return (
        <div style={wrapperStyle}>
            {title && <MyNormalText text={title}/>}
            <div style={containerStyle}
                 onClick={handleToggle}
                 role="switch"
                 aria-checked={isActive}
                 aria-disabled={disabled}>
                <div style={sliderStyle}/>
            </div>
        </div>
    )
}

export default MyToggle
